import { Component, createContext, useContext } from 'react';
import Alert from 'react-bootstrap/Alert';
import { AuthenticationContext, authorizationStates } from '../msal/AuthenticationContext';
import { NotificationContext } from '../context/NotificationContext';
import * as apiCalls from '../logic/apiCalls';

export const TenantContext = createContext();

class TenantProviderInternal extends Component {
    authorizationState = authorizationStates.UNKNOWN;

    constructor() {
        super();

        this.state = {
            isLoading: true,
            tenantId: "",        
            tenantLabel: "unknown",
            enabled: true,
            auditTrailRetentionDays: 365,
            manualLicenseCount: 0,
            marketplaceLicenseCount: 0,
            totalLicenseCount: 0,
            manualSubscriptions: [],
            marketplaceSubscriptions: [],

            showWarningWhenDisabled: () => { 
                return this.state.enabled ? null :
                    <div className='my-4'>
                        <Alert variant='warning' style={{ opacity: 1 }}>
                            Warning: Your account has been disabled! Zorgmessenger events are blocked. Please contact your distributor.
                        </Alert>
                    </div>
            },
            refreshAll: async () => {
                this.refreshAll();
            },
            refreshTenant: async () => {
                this.refreshTenant();
            },
            refreshSubscriptions: async () => {
                this.refreshSubscriptions();
            }
        }
    }

    componentDidMount() {
        this.checkAuthorizationState();
    }

    componentDidUpdate() {
        this.checkAuthorizationState();
    }

    checkAuthorizationState = () => {
        const newAuthorizationState = this.props.authenticationContext.authorizationState;
        if (this.authorizationState !== newAuthorizationState)
        {
            if (newAuthorizationState === authorizationStates.AUTHORIZED)
            {
                this.refreshAll();
            }

            this.authorizationState = newAuthorizationState;
        }
    }

    refreshAll = async () => {
        await this.getTenant();
        await this.getSubscriptions();
    }

    refreshTenant = async () => {
        await this.getTenant();
    }

    refreshSubscriptions = async () => {
        await this.getSubscriptions();
    }

    getTenant = async () => {
        console.log("Start retrieving tenant...");
        
        try {
            console.log("[getTenant] Invoking the back-end API to get the tenant.");

            const tenant = await apiCalls.getTenant(this.props.authenticationContext);

            this.setState({
                tenantId: this.props.authenticationContext.user.tenantId,
                tenantLabel: tenant.tenantLabel,
                enabled: tenant.enabled,
                auditTrailRetentionDays: tenant.auditTrailRetentionDays
            });
        }
        catch (err) {
            console.log(`[getTenant] Error retrieving the tenant information: ${err}`);
            this.props.notificationContext.setCommunicationFailureNotification();
        }
        finally {
            this.setState({
                isLoading: false, 
            });
        }
    }

    getSubscriptions = async () => {
        try {
            console.log("[getSubscriptions] Invoking the back-end API to get all subscriptions of this tenant.");

            const subscriptions = await apiCalls.getSubscriptions(this.props.authenticationContext);

            const manualSubscriptions = subscriptions.filter(sub => sub.type === "Manual");
            const marketplaceSubscriptions = subscriptions.filter(sub => sub.type === "Marketplace" || sub.type === "ManagedByMarketplace");
            
            const manualSubscriptionsCount = this.getSubscriptionsSum(manualSubscriptions);
            const marketplaceSubscriptionsCount = this.getSubscriptionsSum(marketplaceSubscriptions);

            const totalLicenseCount = manualSubscriptionsCount + marketplaceSubscriptionsCount;
            
            this.setState({
                manualLicenseCount: manualSubscriptionsCount,
                marketplaceLicenseCount: marketplaceSubscriptionsCount,
                totalLicenseCount: totalLicenseCount,
                
                manualSubscriptions: manualSubscriptions,
                marketplaceSubscriptions: marketplaceSubscriptions,
            });
        }
        catch (err) {
            // because of refresh no-longer setting error.
            console.log(`[getTenant] Error retrieving the subscriptions: ${err}`);
            //this.props.notificationContext.setCommunicationFailureNotification();
        }
    }

    getSubscriptionsSum = (subscriptions) => {
        let subscriptionSum = 0;
        for (var sub of subscriptions) {
            //if (sub.enabled) {
                subscriptionSum += sub.quantity;
            //}
        }
        return subscriptionSum;
    }

    render() {
        return (
            <TenantContext.Provider value={this.state}>
                {this.props.children}
            </TenantContext.Provider>
        )
    }
}

export const TenantProvider = (props) => {
    const authenticationContext = useContext(AuthenticationContext);       
    const notificationContext = useContext(NotificationContext);
  
    return (
        <TenantProviderInternal authenticationContext={authenticationContext} notificationContext={notificationContext} {...props}/>
    )
}